import axios from 'axios'
const sha1 = require('js-sha1');

const buildConfig = (rfc, config = {}) => {
    const headers = {
        checksum: sha1(rfc),
        ...(config.headers || {}),
    };

    return {
        ...config,
        headers,
    };
};

export default {
    getDashboardMetrics: (rfc, filters, config = {}) => axios.post('dashboard-metrics', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getDashboardAnomalies: (rfc, filters, config = {}) => axios.post('dashboard-anomalies', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getDashboardAnomalyDetail: (rfc, filters, config = {}) => axios.post('dashboard-anomaly-detail', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getDashboardCfdiXml: (rfc, uuid, config = {}) => axios.post('dashboard-cfdi-xml',
        {rfc: rfc, uuid: uuid},
        buildConfig(rfc, { responseType: 'blob', ...config })
    ),
    getDashboardCfdiPdf: (rfc, uuid, config = {}) => axios.post('dashboard-cfdi-pdf',
        {rfc: rfc, uuid: uuid},
        buildConfig(rfc, { responseType: 'blob', ...config })
    ),
    getReviewGraph: (rfc, filters, config = {}) => axios.post('review-graph', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getDashboardRankings: (rfc, filters, config = {}) => axios.post('dashboard-rankings',
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getReviewGraphDetail: (rfc, filters, config = {}) => axios.post('review-graph-detail', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getLastCFDIs: (rfc, filters, config = {}) => axios.post('last-cfdis', 
        {rfc: rfc, filters: filters},
        buildConfig(rfc, config)
    ),
    getDownloadCenterHistory: (rfc, page = 1, take = 20, config = {}) => axios.post('download-center/history',
        {rfc: rfc, page: page, take: take},
        buildConfig(rfc, config)
    ),
    scheduleManualDownload: (rfc, period, config = {}) => axios.post('download-center/manual',
        {rfc: rfc, period: period},
        buildConfig(rfc, config)
    ),
    cancelManualDownload: (rfc, groupId, requestIds = [], config = {}) => axios.post('download-center/manual/cancel',
        {rfc: rfc, group_id: groupId, request_ids: requestIds},
        buildConfig(rfc, config)
    ),
    downloadCfdiFilesBundle: (rfc, requestId, config = {}) => axios.post('download-center/cfdi-files/download',
        {rfc: rfc, request_id: requestId},
        buildConfig(rfc, { responseType: 'blob', ...config })
    ),
    deleteCfdiFilesBundle: (rfc, requestId, config = {}) => axios.post('download-center/cfdi-files/delete',
        {rfc: rfc, request_id: requestId},
        buildConfig(rfc, config)
    ),
}

